export function camelToKebab(string) {
  return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}



// WEBPACK FOOTER //
// ./src/helpers.js